export const FLEX_COLUMN_SX: React.CSSProperties = { display: "flex", flexDirection: "column" };
export const FLEX_ROW_SX: React.CSSProperties = { display: "flex", flexDirection: "row" };
